import { useContext } from 'react';
import { useQuery } from 'react-query';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { heartbeat_api } from '@axo/shared/data-access/api';
import {
  marketCountryKeys,
  parseMarketCountryKey,
} from '../../cache-keys/marketCountryKeys';
import { queryFunction } from '../../query-function';

export function useHeartbeats(marketCountry: string) {
  const { state } = useContext(DataAccessContext);
  const cacheKey = marketCountryKeys.heartbeats({ marketCountry });
  const api = useAPI();
  return useQuery(
    cacheKey,
    queryFunction(heartbeat_api.find(api), ({ queryKey }) => ({
      country: parseMarketCountryKey(queryKey).marketCountry,
    })),
    {
      enabled: state.user.token.length > 0,
    }
  );
}
